// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPreOrderCreateDto
 */
export interface IPreOrderCreateDto {
    /**
     * 
     * @type {number}
     * @memberof IPreOrderCreateDto
     */
    instrument_id: number;
    /**
     * 
     * @type {number}
     * @memberof IPreOrderCreateDto
     */
    amount_cash?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPreOrderCreateDto
     */
    full_liquidation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPreOrderCreateDto
     */
    side: IPreOrderCreateDtoSideEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPreOrderCreateDtoSideEnum {
    BUY = 'BUY',
    SELL = 'SELL'
}


/**
 * Check if a given object implements the IPreOrderCreateDto interface.
 */
export function instanceOfIPreOrderCreateDto(value: object): value is IPreOrderCreateDto {
    if (!('instrument_id' in value) || value['instrument_id'] === undefined) return false;
    if (!('side' in value) || value['side'] === undefined) return false;
    return true;
}

export function IPreOrderCreateDtoFromJSON(json: any): IPreOrderCreateDto {
    return IPreOrderCreateDtoFromJSONTyped(json, false);
}

export function IPreOrderCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPreOrderCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instrument_id': json['instrument_id'],
        'amount_cash': json['amount_cash'] == null ? undefined : json['amount_cash'],
        'full_liquidation': json['full_liquidation'] == null ? undefined : json['full_liquidation'],
        'side': json['side'],
    };
}

export function IPreOrderCreateDtoToJSON(json: any): IPreOrderCreateDto {
    return IPreOrderCreateDtoToJSONTyped(json, false);
}

export function IPreOrderCreateDtoToJSONTyped(value?: IPreOrderCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instrument_id': value['instrument_id'],
        'amount_cash': value['amount_cash'],
        'full_liquidation': value['full_liquidation'],
        'side': value['side'],
    };
}

